import Phaser from 'phaser';

/**
 * Boot scene: configure scale/safe-area aware bootstrap, then hand off to Preload.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  create(): void {
    this.scene.start('Preload');
  }
}
